import { FC, useContext } from "react";

import { RowSize } from "../RowSize";

import {
  ActionButton,
  ActionButtonProps,
} from "@hdi-seguros/web-components.action-button";

import { scrollToTop } from "../MainLayout";

import "./index.css";
import QuotationService from "../../services/quotation";
import { QuotationInfoContext, StepOneFormContext } from "../../../pages/quotation/NewQuote/containers";

interface StepButtonsProps {
  goBackButton?: ActionButtonProps;
  primaryButton: ActionButtonProps;
  secondaryButton?: ActionButtonProps;
  onPressConfirmButton?: () => void;
  onPressBackButton?: () => void;
  htmlTypeConfirmButton?: "submit" | "button";
  showGoBackButton?: boolean;
  customClass?: string;
}

export const StepButtons: FC<StepButtonsProps> = ({
  goBackButton,
  primaryButton,
  secondaryButton,
  onPressConfirmButton = () => {},
  onPressBackButton = () => {},
  htmlTypeConfirmButton = "submit",
  showGoBackButton = true,
  customClass = "",
}) => {
  const { legalRepresentativeSelected } = useContext(StepOneFormContext);

    const {
      quotationInfo,
    } = useContext(QuotationInfoContext);

  const onPressBack = () => {
    onPressBackButton();
    scrollToTop();
  };

  const onPressConfirm = () => {
    if (["Cotizar", "Recotizar"].includes(primaryButton.label) && legalRepresentativeSelected?.length) {      
      QuotationService.postInsertLegalRepresentatives(
        legalRepresentativeSelected, quotationInfo?.token!
      );
    }

    onPressConfirmButton();
    scrollToTop();
  };

  return (
    <RowSize
      className={`steps-buttons-container ${customClass}`}
      rowProps={{ gutter: 0 }}
    >
      {showGoBackButton ? (
        <ActionButton
          onClick={onPressBack}
          label={goBackButton?.label ?? "Anterior"}
          className={`btn-principal-outline-barbuss steps-buttons ${goBackButton?.className ?? ""}`}
          type="secondary"
        />
      ) : (
        <div></div>
      )}
      <div>
        {secondaryButton && (
          <ActionButton
            {...secondaryButton}
            className={`btn-principal-outline-barbuss steps-buttons ${secondaryButton?.className ?? ""}`}
            type="secondary"
          />
        )}
        <ActionButton
          label={primaryButton.label ?? "Continuar"}
          className={`btn-principal-barbuss steps-buttons ${primaryButton?.className ?? ""}`}
          htmlType={htmlTypeConfirmButton}
          onClick={onPressConfirm}
        />
      </div>
    </RowSize>
  );
};
